<template>
  <div class="content">
    <h1>Seattle City Council Districts</h1>

    <div class="l-grid l-grid-xsmall">
      <div class="card" v-for="district in districts">
        <h2 class="card-h2"><span>{{ district.name }}</span></h2>
        <div class="card-content">
          <router-link class="l-width-100 btn teal" :to="{name: 'cityCouncilDistrict', params: {id: district.id}}">View {{district.name}}</router-link>
          <h3>Neighborhoods</h3>
          <ul>
            <li v-for="(neighborhoodName, neighborhoodSlug) in district.neighborhoods">
              <router-link :to="{name: 'neighborhood', params: {id: neighborhoodSlug}}">{{ neighborhoodName }}</router-link>
            </li>
          </ul>
        </div>
      </div>

      <SeattleCityCouncilInformation></SeattleCityCouncilInformation>
    </div>

    <Geo :polygons="polygons"></Geo>
  </div>
</template>

<script>
import Geo from '@/components/Geo'
import SeattleCityCouncilInformation from '@/components/SeattleCityCouncilInformation'

export default {
  name: 'cityCouncilDistricts',

  components: {
    'Geo': Geo,
    'SeattleCityCouncilInformation': SeattleCityCouncilInformation
  },

  mounted: function () {
    this.$store.dispatch('cityCouncilDistrictsView/reset')
    this.$store.dispatch('cityCouncilDistrictsView/fetch')
  },

  computed: {
    districts () {
      return this.$store.getters['cityCouncilDistrictsView/get']
    },

    polygons () {
      let polygons = []
      let vm = this
      let defaultColor = vm.$store.getters.teal.dark.a

      this.districts.forEach(district => {
        polygons.push({
          data: district.polygon,
          options: {
            color: defaultColor,
            weight: 2
          },
          click: function (e) {
            vm.$router.push({name: 'cityCouncilDistrict', params: {id: district.id}})
          },
          mouseover: function (e) {
            this.setStyle({color: vm.$store.getters.orange.default})
          },
          mouseout: function (e) {
            this.setStyle({color: defaultColor})
          },
          tooltip: 'District ' + district.name
        })
      })

      return polygons
    }
  },

  watch: {
    $route: function (to, from) {
      this.$store.dispatch('cityCouncilDistrictsView/reset')
      this.$store.dispatch('cityCouncilDistrictsView/fetch')
    }
  },

  beforeRouteLeave (to, from, next) {
    document.getElementById('app').classList.remove('s-map-collapsed', 's-map-default', 's-map-medium', 's-map-full')
    next()
  }
}
</script>


<style lang="scss">
@import "./src/sass/components/geo";
@import "./src/sass/components/mini-card";
</style>



// WEBPACK FOOTER //
// CityCouncilDistricts.vue?68c12ec2